import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { init } from 'pp-react-l10n';
import HomeMainComponent from './components/HomeMainComponent.js';
import CategoriesMainComponent from './components/CategoriesMainComponent.js';
import ArticleMainComponent from './components/ArticleMainComponent.js';
import ThankyouMainComponent from './components/ThankyouMainComponent';

init({
  content: {
    staticContent,
  },
});

function countryCode(country) {
  if (country === 'GB') {
    country = 'UK';
  }
  return country;
}

if (pageName === 'home') {
  ReactDOM.hydrateRoot(
    document.querySelector('#homeMain-container'),
    <HomeMainComponent
      carouselInfo={carouselInfo}
      userAccountInfo={userAccountInfo}
      encryptedAccountNumber={encryptedAccountNumber}
      topicsInfo={topicsInfo}
      isPopArticleEnabled={isPopArticleEnabled}
      legalFooter={legalFooter}
      locale={locale}
      country={countryCode(dataLayer.contentCountry)}
      tilesInfo={tilesInfo}
      colors={colors}
      totalArticles={totalArticles}
      topicsHash={topicsHash}
      isNewMppEnabled={isNewMppEnabled}
      helpContainer={helpContainer}
    />,
  );
}

if (pageName === 'categories') {
  ReactDOM.hydrateRoot(
    document.querySelector('#categoriesmain-container'),
    <CategoriesMainComponent
      resultsInfo={resultsInfo}
      userAccountInfo={userAccountInfo}
      encryptedAccountNumber={encryptedAccountNumber}
      sections={leftnavData}
      popArticlesHomeInfo={popArticlesHomeInfo}
      legalFooter={legalFooter}
      isPopArticleEnabled={isPopArticleEnabled}
      locale={locale}
      country={countryCode(dataLayer.contentCountry)}
      totalResultsList={totalResultsList}
      topicsHash={topicsHash}
      topics={leftnavData}
      refID={refID}
      isHomeBtnEnabled={isHomeBtnEnabled}
      isNewMppEnabled={isNewMppEnabled}
      helpContainer={helpContainer}
    />,
  );
}

if (pageName === 'article') {
  ReactDOM.hydrateRoot(
    document.querySelector('#articleMainContainer'),
    <ArticleMainComponent
      name="Social"
      articleInfo={articleInfo}
      userAccountInfo={userAccountInfo}
      encryptedAccountNumber={encryptedAccountNumber}
      topicsHash={topicsHash}
      gatewayInfo={gatewayInfo}
      isPopArticleEnabled={isPopArticleEnabled}
      legalFooter={legalFooter}
      popArticlesHomeInfo={popArticlesHomeInfo}
      locale={locale}
      country={countryCode(dataLayer.contentCountry)}
      isRatingEnabled={isRatingEnabled}
      isHomeBreadcrumbEnabled={isHomeBreadcrumbEnabled}
      isNewMppEnabled={isNewMppEnabled}
      helpContainer={helpContainer}
      isECMLive={isECMLive}
    />,
  );
}

if (pageName === 'thankyou') {
  const containerElement = document.querySelector('#thankyouMainContainer');
  const root = createRoot(containerElement);

  root.render(
    <ThankyouMainComponent
      userAccountInfo={userAccountInfo}
      encryptedAccountNumber={encryptedAccountNumber}
      isPopArticleEnabled={isPopArticleEnabled}
      legalFooter={legalFooter}
      locale={locale}
      country={countryCode(dataLayer.contentCountry)}
      tilesInfo={tilesInfo}
      categorieValues={categorieValues}
      colors={colors}
      totalArticles={totalArticles}
      topicsHash={topicsHash}
      isNewMppEnabled={isNewMppEnabled}
      helpContainer={helpContainer}
    />,
  );
}
